import { BASE_URL, MOBILE_BASE_URL } from "../api_const"

export const CART_BASE_URL = BASE_URL + "/cart"
export const URL_FETCH_CART_ITEMS_BY_USER_ID = CART_BASE_URL
export const URL_CREATE_CART = CART_BASE_URL + "/add"
export const URL_REMOVE_CART = CART_BASE_URL + "/remove"
export const URL_UPDATE_CART_QUANTITY =  CART_BASE_URL + "/update"